// ============================================
// ModalBorrarPermanente.js
// ============================================
// Hard delete. Solo aplica a expedientes descartados (el backend devuelve
// 409 NO_DESCARTADA en otro caso). Solo direccion.

import React, { useEffect, useState } from 'react';
import {
  API_BASE_CLI, FF, COLOR_OSCURO, COLOR_GRIS, COLOR_GRIS_CL, COLOR_BORDE,
  COLOR_PELIGRO, botonSecundario, botonPeligro,
  authHeaders, ShellModal, ToastFlotante,
} from './helpersExpedientes';

export default function ModalBorrarPermanente({ expediente, onCerrar, onBorrado, esCelular }) {
  const [confirmTxt, setConfirmTxt] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState(null);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && !enviando) onCerrar(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enviando, onCerrar]);

  const debeEscribir = expediente.folio;
  const valido = confirmTxt.trim().toUpperCase() === debeEscribir.toUpperCase();

  const borrar = async () => {
    if (!valido || enviando) return;
    setEnviando(true);
    setError(null);
    try {
      const r = await fetch(`${API_BASE_CLI}/api/oportunidades/${expediente.id}/permanente`, {
        method: 'DELETE',
        headers: { ...authHeaders() },
      });
      const data = await r.json().catch(() => ({}));
      if (r.status === 401 || r.status === 403) {
        setError('No tienes permisos (solo direccion).');
        return;
      }
      if (r.status === 409 && data?.error === 'NO_DESCARTADA') {
        setError(data?.mensaje || 'Solo se pueden borrar permanentemente expedientes descartados.');
        return;
      }
      if (!r.ok || !data?.ok) throw new Error(data?.error || `Error ${r.status}`);
      setToast({ tipo: 'ok', msg: 'Eliminado permanentemente.' });
      setTimeout(() => onBorrado(), 1000);
    } catch (e) {
      setError(e.message || 'No se pudo borrar.');
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <ShellModal onClose={enviando ? () => {} : onCerrar} ancho={460} esCelular={esCelular}>
        <div style={{
          padding: '18px 22px', borderBottom: `1px solid ${COLOR_BORDE}`,
          display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12,
        }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: COLOR_PELIGRO, fontFamily: FF }}>
              Borrar permanentemente
            </h2>
            <div style={{ marginTop: 4, fontSize: 12, color: COLOR_GRIS_CL }}>{expediente.folio}</div>
          </div>
          <button
            onClick={onCerrar}
            disabled={enviando}
            aria-label="Cerrar"
            style={{
              background: 'transparent', border: 'none',
              cursor: enviando ? 'not-allowed' : 'pointer',
              color: COLOR_GRIS_CL, fontSize: 22, padding: 4,
            }}
          >{'×'}</button>
        </div>

        <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c',
            padding: '12px 14px', borderRadius: 8, fontSize: 13, lineHeight: 1.5, fontWeight: 600,
          }}>
            Esta accion <strong>NO se puede deshacer</strong>.
            <div style={{ marginTop: 6, fontWeight: 500 }}>
              El expediente y su historial se eliminaran de la base de datos.
              Las cotizaciones vinculadas tambien se borraran (cascade).
            </div>
          </div>

          <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            <span style={{ fontSize: 12, color: COLOR_GRIS, fontWeight: 600 }}>
              Para confirmar, escribe <strong>{debeEscribir}</strong> abajo:
            </span>
            <input
              type="text"
              value={confirmTxt}
              onChange={(e) => setConfirmTxt(e.target.value)}
              placeholder={debeEscribir}
              disabled={enviando}
              style={{
                width: '100%', padding: '10px 12px',
                border: `1px solid ${COLOR_BORDE}`, borderRadius: 8,
                fontSize: 14, fontFamily: FF, color: COLOR_OSCURO,
                outline: 'none', boxSizing: 'border-box', background: '#fff',
              }}
            />
          </label>

          {error && (
            <div style={{
              background: '#fef2f2', border: '1px solid #fecaca', color: '#b91c1c',
              padding: '8px 12px', borderRadius: 8, fontSize: 12,
            }}>{error}</div>
          )}
        </div>

        <div style={{
          padding: 16, borderTop: `1px solid ${COLOR_BORDE}`, background: '#fafafa',
          display: 'flex', justifyContent: 'space-between', gap: 10,
        }}>
          <button onClick={onCerrar} disabled={enviando} style={botonSecundario}>Cancelar</button>
          <button
            onClick={borrar}
            disabled={!valido || enviando}
            style={{
              ...botonPeligro,
              opacity: (!valido || enviando) ? 0.5 : 1,
              cursor: (!valido || enviando) ? 'not-allowed' : 'pointer',
            }}
          >{enviando ? 'Borrando...' : 'Borrar permanentemente'}</button>
        </div>
      </ShellModal>
      {toast && <ToastFlotante tipo={toast.tipo}>{toast.msg}</ToastFlotante>}
    </>
  );
}
